"use strict";
var manage_defaults_controller_ts_1 = require("./manage-defaults.controller.ts");
var templateUrl = require("./manage-defaults.html");
exports.manageDefaults = {
    templateUrl: templateUrl,
    controller: manage_defaults_controller_ts_1.ManageDefaultsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {}
};



/** WEBPACK FOOTER **
 ** ./app/manage-defaults/manage-defaults.ts
 **/